import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/img/pagato.svg'
import _imports_1 from '@/img/in_attesa.svg'
import _imports_2 from '@/img/saldo.svg'


const _hoisted_1 = {
  key: 0,
  class: "box d-flex flex-column justify-content-between"
}
const _hoisted_2 = { class: "boxTitle d-flex justify-content-between" }
const _hoisted_3 = { class: "boxButtons" }
const _hoisted_4 = { value: "" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "portafoglioLower mt-3" }
const _hoisted_7 = { class: "portafoglioItem" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "icon pagato" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_9 = { class: "itemLabel" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" € ")
const _hoisted_11 = { class: "grosso" }
const _hoisted_12 = { class: "portafoglioItem" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "icon inAttesa" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_14 = { class: "itemLabel" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" € ")
const _hoisted_16 = { class: "grosso" }
const _hoisted_17 = { class: "portafoglioItem" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "icon saldo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_19 = { class: "itemLabel" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" € ")
const _hoisted_21 = { class: "grosso" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = { class: "text-right" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 1,
  class: "text-right"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_doughnut_chart = _resolveComponent("doughnut-chart")!

  return (_ctx.portafoglio)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Portafoglio",
              text: "Portafoglio"
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("select", {
              class: "boxTitle form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nazioneSelected) = $event))
            }, [
              _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.$localizationService.GetLocalizedValue("Nazione", "Nazione")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nazioni, (item, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.nazioneSelected]
            ])
          ])
        ]),
        _createVNode(_component_doughnut_chart, {
          class: "max-canvas-400",
          value: [_ctx.portafoglio.totaleInAttesa, _ctx.portafoglio.saldoAttuale],
          label: ['In attesa', 'Saldo'],
          color: ['#FFB7F5', '#6C5DD3'],
          centerLabel: "Maturato €",
          centerNumber: _ctx.portafoglio.saldoAttuale + _ctx.portafoglio.totaleInAttesa + _ctx.portafoglio.totalePagato
        }, null, 8, ["value", "centerNumber"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Pagato",
                text: "Pagato"
              }),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$filters.currency(_ctx.portafoglio.totalePagato)), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_localized_text, {
                localizedKey: "In attesa",
                text: "In attesa"
              }),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$filters.currency(_ctx.portafoglio.totaleInAttesa)), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_localized_text, {
                localizedKey: "Saldo",
                text: "Saldo"
              }),
              _hoisted_20
            ]),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$filters.currency(_ctx.portafoglio.saldoAttuale)), 1)
          ])
        ]),
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          (_ctx.nazioneSelected == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Seleziona una nazione per vedere le tue richieste di pagamento",
                  text: "Seleziona una nazione per vedere le tue richieste di pagamento"
                })
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.canRequestPaymentVm.hasContratto)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("b", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Devi firmare il contratto di collaborazione prima di poter richiedere il pagamento",
                          text: "Devi firmare il contratto di collaborazione prima di poter richiedere il pagamento"
                        })
                      ])
                    ]))
                  : (!_ctx.canRequestPaymentVm.canRequest)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Le richieste di pagamento vanno inserite <b>dal giorno {{dayFrom}} al giorno {{dayTo}} del mese </b>",
                          text: "Le richieste di pagamento vanno inserite <b>dal giorno {{dayFrom}} al giorno {{dayTo}} del mese </b>",
                          object: { dayFrom: _ctx.canRequestPaymentVm.pagamentoRequestConfig.dayFrom, dayTo: _ctx.canRequestPaymentVm.pagamentoRequestConfig.dayTo }
                        }, null, 8, ["object"])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (!_ctx.portafoglio.richiestaPagamento)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-primary",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.richiediPagamentoModal && _ctx.richiediPagamentoModal(...args)))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Richiedi pagamento",
                                text: "Richiedi pagamento"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("div", null, [
                                _createElementVNode("b", null, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Richiesta di pagamento inserita:",
                                    text: "Richiesta di pagamento inserita:"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Data ricevuta:",
                                  text: "Data ricevuta:"
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$filters.date(_ctx.portafoglio.richiestaPagamento.dataRicevuta)), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Importo:",
                                  text: "Importo:"
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$filters.currency(_ctx.portafoglio.richiestaPagamento.importo)) + " € ", 1)
                              ]),
                              (_ctx.portafoglio.richiestaPagamento.allegato)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("a", {
                                      href: _ctx.portafoglio.richiestaPagamento.allegato.publicUrl,
                                      target: "_blank"
                                    }, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Vedi allegato",
                                        text: "Vedi allegato"
                                      })
                                    ], 8, _hoisted_29)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-danger mt-2",
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.annullaRichiestaPagamento && _ctx.annullaRichiestaPagamento(...args)))
                                }, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Annulla richiesta di pagamento",
                                    text: "Annulla richiesta di pagamento"
                                  })
                                ])
                              ])
                            ]))
                      ], 64))
              ], 64))
        ])
      ]))
    : _createCommentVNode("", true)
}